module.exports = __webpack_public_path__ + "static/media/phonemeIsolation-klarte-oppgaver.87cbeb28.mp3";